export const getCurrentYear = () => {
  const date = new Date();
  return date.getFullYear();
};
